import { render, staticRenderFns } from "./GroupDashboard.vue?vue&type=template&id=79efac4d&scoped=true&lang=pug"
import script from "./GroupDashboard.vue?vue&type=script&lang=js"
export * from "./GroupDashboard.vue?vue&type=script&lang=js"
import style0 from "./GroupDashboard.vue?vue&type=style&index=0&id=79efac4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79efac4d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
